
import { supabase } from "@/integrations/supabase/client";
import { MembershipVerificationResult } from "../types/membership";

export async function verifyMembership(
  membershipId: string,
  verificationToken: string
): Promise<MembershipVerificationResult> {
  console.log(`Vérification d'adhésion avec id=${membershipId}, token=${verificationToken}`);
  
  try {
    // Use the secure function to verify token without exposing sensitive data
    const { data, error } = await supabase
      .rpc('verify_membership_token', {
        membership_id: membershipId,
        token: verificationToken
      })
      .single();
    
    if (error || !data) {
      console.log("Erreur lors de la vérification de l'adhésion:", error);
      throw new Error("Le lien de vérification est invalide ou a expiré.");
    }
    
    // Check if already verified
    if (data.payment_status === "pending_payment" || data.payment_status === "paid") {
      return {
        success: true,
        membershipId,
        message: data.membership_type === "donor" 
          ? "Don déjà vérifié" 
          : "Adhésion déjà vérifiée",
        membership: data
      };
    }
    
    // Update the membership status using the secure function
    const { data: updateSuccess, error: updateError } = await supabase
      .rpc('update_membership_verification_status', {
        membership_id: membershipId,
        token: verificationToken,
        new_status: 'pending_payment'
      });
    
    if (updateError || !updateSuccess) {
      console.error("Erreur lors de la mise à jour du statut de l'adhésion:", updateError);
      throw new Error("Une erreur est survenue lors de la vérification.");
    }
    
    return {
      success: true,
      membershipId,
      message: data.membership_type === "donor" 
        ? "Don vérifié avec succès" 
        : "Adhésion vérifiée avec succès",
      membership: data
    };
  } catch (error: any) {
    console.error("Erreur lors de la vérification:", error);
    throw error;
  }
}
